import { useQuery } from "@tanstack/react-query";

import { getPracticeManagementCropEmissionFactors } from "services";

import { PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_CROP_EMISSION_FACTORS } from "consts";

export const usePracticeManagementCropEmissionFactors = (version?: string, country: PracticeManagement.CountryCode = "global") =>
  useQuery({
    queryKey: [PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_CROP_EMISSION_FACTORS, country, version],
    queryFn: async () => {
      const factors = await getPracticeManagementCropEmissionFactors(version, country);
      return factors.map((factor) => ({
        ...factor,
        editingKey: factor.cropId,
      }));
    },
    staleTime: 1000 * 60 * 60, // 1h
    gcTime: 1000 * 60 * 24,
  });
